import { CursorManager } from './components/CursorManager'
import { FullscreenButton } from './components/FullscreenButton'
import { RotationPrompt } from './components/RotationPrompt'
import { GameProvider } from './contexts/GameContext'
import GameOverScreen from './screens/GameOverScreen'
import { GameScreen } from './screens/GameScreen'
import { HomeScreen } from './screens/HomeScreen'
import { InstructionsScreen } from './screens/InstructionsScreen'
import { RankingScreen } from './screens/Ranking'

export function App() {
	return (
		<GameProvider>
			<CursorManager />
			<div className="relative h-dvh w-dvw overflow-hidden">
				<RotationPrompt />

				<FullscreenButton />

				<HomeScreen />

				<InstructionsScreen />

				<GameScreen />

				<GameOverScreen />

				<RankingScreen />
			</div>
		</GameProvider>
	)
}
